import { render, staticRenderFns } from "./EditSellCabinet.vue?vue&type=template&id=24fbc105&scoped=true&"
import script from "./EditSellCabinet.vue?vue&type=script&lang=js&"
export * from "./EditSellCabinet.vue?vue&type=script&lang=js&"
import style0 from "./EditSellCabinet.vue?vue&type=style&index=0&id=24fbc105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fbc105",
  null
  
)

component.options.__file = "EditSellCabinet.vue"
export default component.exports